(function () {
  'use strict';

  var LOW_STOCK_THRESHOLD = 5;

  var sheet = document.getElementById('QuickAddSheet');
  if (!sheet) return;

  var overlay = sheet.querySelector('.QuickAddSheet__Overlay');
  var panel   = sheet.querySelector('.QuickAddSheet__Panel');
  var body    = document.getElementById('QuickAddSheetBody');
  var cartBtn = document.getElementById('QuickAddSheetBtn');

  var currentProduct  = null;
  var selectedOptions = [];
  var colorProducts   = [];  // multi-product color mode
  var lowStockMap     = {};  // handle -> [lowStockOptionValues]

  // ----------------------------------------
  // Open
  // ----------------------------------------
  window.quickAddSheet = {
    open: function (triggerEl) {
      var handle = triggerEl.dataset.quickSheet;
      if (!handle) return;

      // Parse Liquid-embedded low-stock map: "handle:val|val|;handle:val|;"
      lowStockMap = {};
      var rawMap = triggerEl.dataset.lowStockMap || '';
      if (rawMap) {
        rawMap.split(';').forEach(function (entry) {
          if (!entry) return;
          var colon = entry.indexOf(':');
          if (colon < 0) return;
          var h = entry.slice(0, colon);
          var vals = entry.slice(colon + 1).split('|').filter(Boolean);
          lowStockMap[h] = vals;
        });
      }

      var colorHandles = triggerEl.dataset.colorProducts
        ? triggerEl.dataset.colorProducts.split(',').filter(Boolean)
        : [];

      var productId = triggerEl.dataset.productId || '';
      var colorLabel = triggerEl.dataset.colorLabel || 'Color';

      // GA4: quick-addシートを開いたイベント
      if (typeof gtag === 'function') {
        gtag('event', 'quick_add_open', {
          product_handle: handle,
          product_id: productId
        });
      }

      body.innerHTML = '<p style="padding:20px;text-align:center;">読み込み中...</p>';
      cartBtn.disabled = true;
      cartBtn.textContent = 'カートに追加';
      cartBtn.classList.remove('is-notify');
      updateWishBtn(productId);

      sheet.classList.add('is-active');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          sheet.classList.add('is-open');
        });
      });
      document.body.style.overflow = 'hidden';

      if (colorHandles.length > 1) {
        colorProducts = [];
        Promise.all(colorHandles.map(function (h) {
          return fetch('/products/' + h + '.js')
            .then(function (r) {
              if (!r.ok) throw new Error('HTTP ' + r.status);
              return r.json();
            });
        }))
          .then(function (products) {
            colorProducts = products;
            renderBodyMultiColor(products, handle, colorLabel);
          })
          .catch(function (err) {
            body.innerHTML = '<p style="padding:20px;text-align:center;color:#c00;">エラー: ' + err.message + '</p>';
          });
      } else {
        colorProducts = [];
        fetch('/products/' + handle + '.js')
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
          })
          .then(function (product) {
            currentProduct  = product;
            var optCount = product.options.filter(function (o) {
              return (typeof o === 'string' ? o : o.name) !== 'Title';
            }).length;
            selectedOptions = new Array(optCount).fill(null);
            renderBody(product);
          })
          .catch(function (err) {
            body.innerHTML = '<p style="padding:20px;text-align:center;color:#c00;">エラー: ' + err.message + '</p>';
          });
      }
    },
    close: close
  };

  // ----------------------------------------
  // Close
  // ----------------------------------------
  function close() {
    console.log('[QA] close() called. sheet classes:', sheet.className);
    sheet.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      console.log('[QA] close() removing is-active');
      sheet.classList.remove('is-active');
      currentProduct  = null;
      selectedOptions = [];
      colorProducts   = [];
    }, 350);
  }

  overlay.addEventListener('click', close);

  // bfcache復元時（戻るボタン）はシートを強制リセット
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      sheet.classList.remove('is-open', 'is-active');
      document.body.style.overflow = '';
      currentProduct  = null;
      selectedOptions = [];
      colorProducts   = [];
      body.innerHTML  = '';
      cartBtn.disabled = true;
      cartBtn.textContent = 'カートに追加';
      cartBtn.classList.remove('is-notify');
    }
  });

  var touchStartY = 0;
  panel.addEventListener('touchstart', function (e) {
    touchStartY = e.touches[0].clientY;
  }, { passive: true });
  panel.addEventListener('touchend', function (e) {
    if (e.changedTouches[0].clientY - touchStartY > 60) close();
  }, { passive: true });

  // ----------------------------------------
  // Render: single product mode
  // ----------------------------------------
  function renderBody(product) {
    var html = '';
    var displayIdx = 0;
    product.options.forEach(function (option, origIdx) {
      var optionName = typeof option === 'string' ? option : option.name;
      if (optionName === 'Title') return;
      var isColor = /color|colour|カラー|色/i.test(optionName);
      var displayName = optionName.charAt(0).toUpperCase() + optionName.slice(1);
      html += '<div class="QuickAdd__OptionGroup">';
      html += '<div class="QuickAdd__OptionLabel">' + displayName;
      if (isColor) {
        var colorCount = product.options_with_values
          ? product.options_with_values[origIdx].values.length
          : countUnique(product.variants, origIdx);
        html += '<span>' + colorCount + '</span>';
      }
      html += '<span class="QuickAdd__OutOfStock" id="QuickAddOOS_' + displayIdx + '" style="display:none">Out of Stock</span>';
      html += '</div>';
      html += isColor ? renderColorOptions(product, origIdx, displayIdx) : renderSizeOptions(product, origIdx, displayIdx);
      html += '</div>';
      displayIdx++;
    });
    body.innerHTML = html;
    autoSelectSingle();
  }

  // ----------------------------------------
  // Render: multi-product color mode
  // ----------------------------------------
  function renderBodyMultiColor(products, activeHandle, colorLabel) {
    var active = products.find(function (p) { return p.handle === activeHandle; }) || products[0];
    currentProduct  = active;
    selectedOptions = buildSelectedOptions(active);
    body.innerHTML  = buildColorSection(products, activeHandle, colorLabel) + buildSizeSections(active);
    autoSelectSingle();
  }

  function autoSelectSingle() {
    var byIndex = {};
    body.querySelectorAll('[data-option-index]').forEach(function (btn) {
      var idx = btn.dataset.optionIndex;
      if (!byIndex[idx]) byIndex[idx] = [];
      if (!btn.dataset.soldout) byIndex[idx].push(btn);
    });
    Object.keys(byIndex).forEach(function (idx) {
      if (byIndex[idx].length === 1) {
        var btn = byIndex[idx][0];
        btn.classList.add('is-selected');
        selectedOptions[parseInt(idx, 10)] = btn.dataset.optionValue;
      }
    });
    updateCartButton();
  }

  function buildSelectedOptions(product) {
    var count = product.options.filter(function (opt) {
      var name = typeof opt === 'string' ? opt : opt.name;
      return !/color|colour|カラー|色/i.test(name) && name !== 'Title';
    }).length;
    return new Array(count).fill(null);
  }

  function getColorName(product) {
    var parts = product.title.split(' - ');
    return parts.length > 1 ? parts[parts.length - 1] : product.title;
  }

  function buildColorSection(products, activeHandle, colorLabel) {
    var active = products.find(function (p) { return p.handle === activeHandle; }) || products[0];
    var label = colorLabel || 'Color';
    var html = '<div class="QuickAdd__OptionGroup">';
    html += '<div class="QuickAdd__OptionLabel">' + escHtml(label) + ' <span>' + products.length + '</span>'
      + ' <span class="QuickAdd__ColorName">' + escHtml(getColorName(active)) + '</span>'
      + '<span class="QuickAdd__ColorLowStock" style="display:none;color:#E07B2A;margin-left:8px;">残りわずか</span>'
      + '</div>';
    html += '<div class="QuickAdd__ColorList">';
    products.forEach(function (p) {
      var src = typeof p.featured_image === 'string' ? p.featured_image
              : (p.featured_image ? p.featured_image.src : '');
      var img = src ? src.replace(/(\.[^.]+)$/, '_160x$1') : '';
      html += '<button class="QuickAdd__ColorBtn' + (p.handle === activeHandle ? ' is-selected' : '') + '"'
        + ' data-color-product="' + escHtml(p.handle) + '">';
      if (img) html += '<img src="' + img + '" alt="' + escHtml(p.title) + '">';
      html += '</button>';
    });
    html += '</div></div>';
    return html;
  }

  function buildSizeSections(product) {
    var html = '';
    var remapped = 0;
    product.options.forEach(function (option, origIdx) {
      var optionName = typeof option === 'string' ? option : option.name;
      if (/color|colour|カラー|色/i.test(optionName)) return;
      if (optionName === 'Title') return;
      html += '<div class="QuickAdd__OptionGroup" data-size-group>';
      var displayName = optionName.charAt(0).toUpperCase() + optionName.slice(1);
      html += '<div class="QuickAdd__OptionLabel">' + displayName;
      html += '<span class="QuickAdd__OutOfStock" id="QuickAddOOS_' + remapped + '" style="display:none">Out of Stock</span>';
      html += '</div>';
      html += renderSizeOptionsAt(product, origIdx, remapped);
      html += '</div>';
      remapped++;
    });
    return html;
  }

  function renderSizeOptionsAt(product, origIdx, displayIdx) {
    var seen = {};
    var html = '<div class="QuickAdd__SizeList">';
    var lsVals = lowStockMap[product.handle] || [];
    product.variants.forEach(function (v) {
      var val = v.options[origIdx];
      if (seen[val]) return;
      seen[val] = true;
      var soldout = !v.available;
      var qty = (v.inventory_quantity != null) ? v.inventory_quantity : 0;
      var lowStock = !soldout && (lsVals.indexOf(val) !== -1 || (qty > 0 && qty <= LOW_STOCK_THRESHOLD));
      html += '<button class="QuickAdd__SizeBtn' + (soldout ? ' is-soldout' : '') + '"'
        + ' data-option-index="' + displayIdx + '"'
        + ' data-option-value="' + escHtml(val) + '"'
        + (soldout ? ' data-soldout="true"' : '')
        + ' data-inventory="' + qty + '">'
        + escHtml(val)
        + (lowStock ? '<span class="QuickAdd__LowStockDot" style="position:absolute;top:4px;right:4px;width:5px;height:5px;background:#E07B2A;border-radius:50%;"></span>' : '')
        + '</button>';
    });
    html += '</div>';
    return html;
  }

  function renderColorOptions(product, optIdx, displayIdx) {
    var seen = {};
    var html = '<div class="QuickAdd__ColorList">';
    product.variants.forEach(function (v) {
      var val = v.options[optIdx];
      if (seen[val]) return;
      seen[val] = true;
      var fallback = typeof product.featured_image === 'string' ? product.featured_image
                   : (product.featured_image ? product.featured_image.src : '');
      var img = v.featured_image
        ? v.featured_image.src.replace(/(\.[^.]+)$/, '_160x$1')
        : (fallback ? fallback.replace(/(\.[^.]+)$/, '_160x$1') : '');
      html += '<button class="QuickAdd__ColorBtn" data-option-index="' + displayIdx + '" data-option-value="' + escHtml(val) + '">';
      if (img) html += '<img src="' + img + '" alt="' + escHtml(val) + '">';
      html += '</button>';
    });
    html += '</div>';
    return html;
  }

  function renderSizeOptions(product, optIdx, displayIdx) {
    var seen = {};
    var html = '<div class="QuickAdd__SizeList">';
    var lsVals = lowStockMap[product.handle] || [];
    product.variants.forEach(function (v) {
      var val = v.options[optIdx];
      if (seen[val]) return;
      seen[val] = true;
      var soldout = !v.available;
      var qty = (v.inventory_quantity != null) ? v.inventory_quantity : 0;
      var lowStock = !soldout && (lsVals.indexOf(val) !== -1 || (qty > 0 && qty <= LOW_STOCK_THRESHOLD));
      html += '<button class="QuickAdd__SizeBtn' + (soldout ? ' is-soldout' : '') + '"'
        + ' data-option-index="' + displayIdx + '"'
        + ' data-option-value="' + escHtml(val) + '"'
        + (soldout ? ' data-soldout="true"' : '')
        + ' data-inventory="' + qty + '">'
        + escHtml(val)
        + (lowStock ? '<span class="QuickAdd__LowStockDot" style="position:absolute;top:4px;right:4px;width:5px;height:5px;background:#E07B2A;border-radius:50%;"></span>' : '')
        + '</button>';
    });
    html += '</div>';
    return html;
  }

  // ----------------------------------------
  // Option selection (delegated on body — attached once)
  // ----------------------------------------
  body.addEventListener('click', function (e) {
    // Multi-color: switch product
    var colorProductBtn = e.target.closest('[data-color-product]');
    if (colorProductBtn) {
      var newHandle = colorProductBtn.dataset.colorProduct;
      var newProduct = colorProducts.find(function (p) { return p.handle === newHandle; });
      if (!newProduct) return;

      currentProduct  = newProduct;
      selectedOptions = buildSelectedOptions(newProduct);

      body.querySelectorAll('[data-color-product]').forEach(function (b) {
        b.classList.toggle('is-selected', b.dataset.colorProduct === newHandle);
      });
      var nameEl = body.querySelector('.QuickAdd__ColorName');
      if (nameEl) nameEl.textContent = getColorName(newProduct);
      var colorLsEl = body.querySelector('.QuickAdd__ColorLowStock');
      if (colorLsEl) colorLsEl.style.display = 'none';
      body.querySelectorAll('[data-size-group]').forEach(function (g) { g.remove(); });
      body.insertAdjacentHTML('beforeend', buildSizeSections(newProduct));
      autoSelectSingle();
      updateCartButton();
      updateWishBtn(String(newProduct.id));
      return;
    }

    // Size / option selection
    var btn = e.target.closest('[data-option-index]');
    if (!btn || btn.dataset.soldout) return;

    var idx = parseInt(btn.dataset.optionIndex, 10);
    var val = btn.dataset.optionValue;

    body.querySelectorAll('[data-option-index="' + idx + '"]').forEach(function (b) {
      b.classList.remove('is-selected');
    });
    btn.classList.add('is-selected');
    selectedOptions[idx] = val;

    updateCartButton();
  });

  // ----------------------------------------
  // Cart button state
  // ----------------------------------------
  function updateLowStockLabels() {
    var handle = currentProduct ? currentProduct.handle : '';
    var lsVals = lowStockMap[handle] || [];
    // 選択中サイズが残りわずかのときだけカラーラベルを表示
    var colorLsEl = body.querySelector('.QuickAdd__ColorLowStock');
    if (colorLsEl) {
      var sizeIsLowStock = selectedOptions.some(function (val) {
        return val !== null && lsVals.indexOf(val) !== -1;
      });
      colorLsEl.style.display = sizeIsLowStock ? '' : 'none';
    }
  }

  function updateCartButton() {
    updateLowStockLabels();
    var allSelected = selectedOptions.every(function (v) { return v !== null; });
    if (!allSelected) {
      cartBtn.disabled = true;
      cartBtn.textContent = 'カートに追加';
      cartBtn.classList.remove('is-notify');
      return;
    }

    var variant = findVariant(selectedOptions);
    if (!variant) {
      cartBtn.disabled = true;
      return;
    }

    var price = formatMoney(variant.price);
    if (variant.available) {
      cartBtn.disabled = false;
      cartBtn.innerHTML = 'Add to Cart <span style="margin-left:8px">' + price + '</span>';
      cartBtn.classList.remove('is-notify');
      cartBtn.dataset.variantId = variant.id;
      body.querySelectorAll('.QuickAdd__OutOfStock').forEach(function (el) {
        el.style.display = 'none';
      });
    } else {
      cartBtn.disabled = false;
      cartBtn.innerHTML = 'Notify Me <span style="margin-left:8px">' + price + '</span>';
      cartBtn.classList.add('is-notify');
      cartBtn.dataset.variantId = '';
      selectedOptions.forEach(function (_, i) {
        var el = document.getElementById('QuickAddOOS_' + i);
        if (el) el.style.display = 'inline';
      });
    }
  }

  // ----------------------------------------
  // Product Warnings (Elspw) popup
  // ----------------------------------------
  function showElspwWarning(message, onOk) {
    var overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:2147483647;display:flex;align-items:center;justify-content:center;';

    var dialog = document.createElement('div');
    dialog.style.cssText = 'background:#fff;padding:32px 24px;max-width:480px;width:90%;text-align:center;line-height:1.7;font-size:14px;';

    var msgDiv = document.createElement('div');
    msgDiv.innerHTML = message;
    msgDiv.style.marginBottom = '24px';

    var btnWrap = document.createElement('div');
    btnWrap.style.cssText = 'display:flex;gap:12px;justify-content:center;';

    var cancelBtn = document.createElement('button');
    cancelBtn.textContent = 'Cancel';
    cancelBtn.style.cssText = 'padding:12px 32px;background:#e74c3c;color:#fff;border:none;cursor:pointer;font-size:14px;';

    var okBtn = document.createElement('button');
    okBtn.textContent = 'OK';
    okBtn.style.cssText = 'padding:12px 32px;background:#2ecc71;color:#fff;border:none;cursor:pointer;font-size:14px;';

    cancelBtn.addEventListener('click', function () {
      document.body.removeChild(overlay);
      cartBtn.disabled = false;
    });
    okBtn.addEventListener('click', function () {
      document.body.removeChild(overlay);
      onOk();
    });

    btnWrap.appendChild(cancelBtn);
    btnWrap.appendChild(okBtn);
    dialog.appendChild(msgDiv);
    dialog.appendChild(btnWrap);
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);
  }

  // ----------------------------------------
  // Add to cart
  // ----------------------------------------
  cartBtn.addEventListener('click', function () {
    var variantId = cartBtn.dataset.variantId;
    if (!variantId) return;

    // Elspw (Product Warnings) チェック
    var elspwAlerts = (window.Elspw && window.Elspw.config && window.Elspw.config.alerts) ? window.Elspw.config.alerts : [];
    var productTags = (currentProduct && Array.isArray(currentProduct.tags)) ? currentProduct.tags : [];
    var matchedAlert = null;
    for (var ai = 0; ai < elspwAlerts.length; ai++) {
      var a = elspwAlerts[ai];
      if (a.enabled && productTags.indexOf(a.tag) !== -1) { matchedAlert = a; break; }
    }

    if (matchedAlert) {
      cartBtn.disabled = true;
      var msg = (matchedAlert.message || '').replace(/\{\{product\.title\}\}/g, currentProduct ? currentProduct.title : '');
      console.log('[QA] Elspw warning shown, variantId:', variantId);
      showElspwWarning(msg, function () {
        console.log('[QA] onOk called, calling doAddToCart. variantId:', variantId, 'sheet classes:', sheet.className);
        doAddToCart(variantId);
      });
      return;
    }

    doAddToCart(variantId);
  });

  function doAddToCart(variantId) {
    console.log('[QA] doAddToCart start. variantId:', variantId);
    cartBtn.disabled = true;
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        cartBtn.disabled = false;
        if (r.ok) {
          // GA4: quick-addからカート追加成功イベント
          if (typeof gtag === 'function') {
            var addedVariant = findVariant(selectedOptions);
            gtag('event', 'quick_add_to_cart', {
              currency: 'JPY',
              value: addedVariant ? addedVariant.price / 100 : 0,
              items: [{
                item_id: String(currentProduct ? currentProduct.id : ''),
                item_name: currentProduct ? currentProduct.title : '',
                item_variant: addedVariant ? addedVariant.title : '',
                price: addedVariant ? addedVariant.price / 100 : 0,
                quantity: 1
              }]
            });
          }
          console.log('[QA] fetch OK, dispatching product:added, then close. sheet classes:', sheet.className);
          document.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: {} }));
          console.log('[QA] after product:added, sheet classes:', sheet.className);
          close();
        } else {
          r.json().then(function (data) { alert(data.message || 'エラーが発生しました'); });
        }
      })
      .catch(function () {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        cartBtn.disabled = false;
      });
  }

  // ----------------------------------------
  // Wishlist (Growave SSW)
  // ----------------------------------------
  var wishIcon = document.getElementById('QuickAddFaveIcon');
  function updateWishBtn(productId) {
    if (!wishIcon) return;
    wishIcon.dataset.productId = productId || '';
    wishIcon.dataset.params = productId
      ? JSON.stringify({ product_id: productId, event: 'fave_button', page: 'product_profile' })
      : '{}';
    wishIcon.className = 'ssw-icon-heart-o ssw-fave-icon ssw-wishlist-element ssw-not-synch';
    if (productId) {
      window.dispatchEvent(new CustomEvent('ssw.faveicon.init'));
    }
  }

  // ----------------------------------------
  // Helpers
  // ----------------------------------------
  function findVariant(opts) {
    if (!currentProduct) return null;
    if (colorProducts.length > 0) {
      // Multi-color mode: opts are remapped to non-color options only
      var origIndices = [];
      currentProduct.options.forEach(function (opt, i) {
        var name = typeof opt === 'string' ? opt : opt.name;
        if (!/color|colour|カラー|色/i.test(name) && name !== 'Title') {
          origIndices.push(i);
        }
      });
      return currentProduct.variants.find(function (v) {
        return origIndices.every(function (origIdx, remapped) {
          return v.options[origIdx] === opts[remapped];
        });
      }) || null;
    }
    // Single product mode: map display indices (Title-excluded) to original variant option indices
    var singleOrigIndices = [];
    currentProduct.options.forEach(function (opt, i) {
      if ((typeof opt === 'string' ? opt : opt.name) !== 'Title') {
        singleOrigIndices.push(i);
      }
    });
    if (singleOrigIndices.length === 0) return currentProduct.variants[0] || null;
    return currentProduct.variants.find(function (v) {
      return singleOrigIndices.every(function (origIdx, remapped) {
        return v.options[origIdx] === opts[remapped];
      });
    }) || null;
  }

  function formatMoney(cents) {
    return '¥' + Math.round(cents / 100).toLocaleString();
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function countUnique(variants, optIdx) {
    var seen = {};
    variants.forEach(function (v) { seen[v.options[optIdx]] = true; });
    return Object.keys(seen).length;
  }
})();
